export enum FaseId {
  SEGURANCA = 1,
  FISCAL = 2,
  PRODUTIVO = 3,
  IMPRODUTIVO = 4,
  EMBALAGEM = 5,
  DAR_BAIXA = 100,
}
